import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
const links = [{
  label: 'For Brands',
  to: '/for-brands'
}, {
  label: 'For Marketing Agencies',
  to: '/for-marketing-agencies'
}, {
  label: 'For Talent Agencies',
  to: '/for-talent'
}, {
  label: 'Case Studies',
  to: '/case-studies'
}, {
  label: 'Pricing',
  to: '/pricing'
}];
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setIsOpen(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-926" data-mp="ekpetamperhp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-927" data-mp="9me4yzwesgzh">
        <div className="flex justify-between items-center h-16" data-id="element-928" data-mp="1px9o8e0lrif6">
          <div className="flex items-center" data-id="element-929" data-mp="1kzq8f9o9axl4">
            <Link to="/" onClick={close} className="flex-shrink-0 flex items-center" data-id="element-930" data-mp="1kyyd7zykn1vd">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-7 w-auto" data-id="element-931" data-mp="enkiamducppz" />
            </Link>
            <div className="hidden md:ml-10 md:flex md:space-x-7" data-id="element-932" data-mp="om07ukx7zqxd">
              {links.map(l => <NavLink key={l.to} to={l.to} className={({
              isActive
            }) => `text-sm font-medium transition-colors ${isActive ? 'text-zano-pink' : 'text-gray-600 hover:text-zano-charcoal'}`} data-id="element-933" data-mp="3n45ipeseqahh">
                  {l.label}
                </NavLink>)}
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-4" data-id="element-934" data-mp="34btgcs1r797c">
            <a href="https://app.zanoplatform.com/sign-in" className="text-sm font-medium transition-colors text-gray-600 hover:text-zano-charcoal" data-id="element-935" data-mp="39bz9kcno93rj">
              Login
            </a>
            <Button variant="primary" onClick={() => navigate('/pricing')} data-id="element-936" data-mp="2wcyia04g0fh4">
              Start Free Trial
            </Button>
          </div>
          <div className="flex items-center md:hidden" data-id="element-937" data-mp="3b0bc0c4elril">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-zano-charcoal" data-id="element-938" data-mp="361q7i0i4cloc">
              {isOpen ? <X size={24} data-id="element-939" data-mp="2ie8l6khmifsr" /> : <Menu size={24} data-id="element-940" data-mp="2ddkmrdr2ewoi" />}
            </button>
          </div>
        </div>
      </div>
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 px-4 pt-2 pb-4 space-y-1" data-id="element-941" data-mp="2sb4ombso0bqg">
          {links.map(l => <NavLink key={l.to} to={l.to} onClick={close} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-zano-charcoal hover:bg-gray-50" data-id="element-942" data-mp="2nap7d959ik37">
              {l.label}
            </NavLink>)}
          <div className="mt-4 pt-4 border-t border-gray-100 flex flex-col gap-2" data-id="element-943" data-mp="a37j1ypt567a">
            <a href="https://app.zanoplatform.com/sign-in" onClick={close} data-id="element-944" data-mp="f4wsxb1andts">
              <Button variant="secondary" className="w-full justify-center" data-id="element-945" data-mp="14m2g93wc195">
                Login
              </Button>
            </a>
            <Link to="/pricing" onClick={close} data-id="element-946" data-mp="567n4gmo9jtw">
              <Button variant="primary" className="w-full justify-center" data-id="element-947" data-mp="svjwbgi01rw7">
                Start Free Trial
              </Button>
            </Link>
          </div>
        </div>}
    </nav>;
};